import base_speedTest_component from '#BASE/components/speedTest/speedTest.component';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import logoComponent from 'XY/views/Logo.vue';
import app_download_component from 'XY/views/DownloadCenter/LoginPageAppDownload.vue';
import CommonFooter from 'XY/views/CommonFooter.vue';
import userInfo_component from 'BASE/components/userInfo.component'; //權限等狀態初始化須使用
import ajaxSetting from 'BASE/components/ajaxSetting.component';
import ToastNotificationComponent from 'BASE/components/notification/toastNotification.component';

export default {
    name: 'SpeedTest',
    mixins: [base_speedTest_component, websiteInfoUtil, userInfo_component, ajaxSetting],
    data: function () {
        return {
            LevelList: [
                {
                    speed: 50,
                    class: 'fast',
                    text: '极速',
                }, //speed為ms
                {
                    speed: 100,
                    class: 'soso',
                    text: '流畅',
                },
                {
                    speed: 500,
                    class: 'slow',
                    text: '拥挤',
                },
            ],
            goLinkPage: '/Login',
            downloadUrls: {
                iosUrl: '',
                androidUrl: '',
                AFKPcUrl: ''
            },
            
            // 覆寫父類別的資料撈取配置，自訂XY商戶需要的資料
            dataConfig: {
                parallel: []
            }
        };
    },
    components: {
        logo: logoComponent,
        app_download_component,
        CommonFooter,
        ToastNotificationComponent
    },
    methods: {
        checkDomainResult(text, result) {
            if (typeof result !== 'undefined') {
                if (result) text = `<div>检测域名：${this.DomainName}</div><p class="red_text">(域名正确)</p>`;
                else text = `<div>检测域名：${this.DomainName}</div><p class="red_text">(此为假域名，请勿链接)</p>`;
            }
            let dialog = this.$dialog.get('speedtest_warning');
            if (dialog) 
                dialog.show({ message: text });

        },
        goChat() {
            window.location.href = window.location.origin + "/ChatAnonymity";
        },
        onAppDownloadReady: function() {
            if (this.$refs.AppDownload) {
                this.downloadUrls.iosUrl = this.$refs.AppDownload.iosUrl || '';
                this.downloadUrls.androidUrl = this.$refs.AppDownload.androidUrl || '';
                this.downloadUrls.AFKPcUrl = this.$refs.AppDownload.AFKPcUrl || '';
            }
        }
    },
};
